// Central season configuration.
// Bump these three values each year — everything else derives from them.

// The season we're currently running (NFL seasons are labeled by their starting year,
// so the "2026-27 season" is 2026).
export const CURRENT_SEASON = 2026;

// Seasons offered in admin dropdowns (newest first).
export const AVAILABLE_SEASONS = [2026, 2025, 2024];

// Anchor = the Monday immediately after Week 1's Sunday slate, in Eastern Time.
// 2026: Week 1 opens Thu Sep 10, first Sunday Sep 13, so the anchor Monday is Sep 14.
// Adjust if the official NFL schedule shifts the opener.
export const WEEK1_ANCHOR = '2026-09-14';

export const TOTAL_WEEKS = 18;

// All selectable weeks, 1..18.
export const AVAILABLE_WEEKS = Array.from({ length: TOTAL_WEEKS }, (_, i) => i + 1);

// Current time as a Date shifted into Eastern Time (the whole app reasons in ET).
export const nowEastern = (): Date =>
  new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));

// Compute the current NFL week from today's date (Eastern Time).
export const getCurrentNFLWeek = (): number => {
  const now = nowEastern();
  const anchor = new Date(WEEK1_ANCHOR);

  // Before the anchor Monday we're still in Week 1 (or preseason).
  if (now < anchor) {
    return 1;
  }

  const msPerWeek = 7 * 24 * 60 * 60 * 1000;
  const weeksSinceAnchor = Math.ceil((now.getTime() - anchor.getTime()) / msPerWeek);
  return Math.min(weeksSinceAnchor + 1, TOTAL_WEEKS);
};
